import React, { useState } from "react";
import { Box } from "@mui/material";

// Template38: Página sobre JR Pass
// Copia DIRECTA del componente JRPass.jsx de guia-kioto, adaptado para usar las props del sistema guia
const Template38 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const [imgError, setImgError] = useState({ trainSticker: false });
	const isSmallScreen = window.innerWidth <= 600;
	const trainStickerError = imgError.trainSticker;
	const setTrainStickerError = (v) =>
		setImgError((prev) => ({ ...prev, trainSticker: v }));

	const getImageSrc = (id, def) =>
		(page.images && page.images.find((img) => img?.id === id)?.src) || def;

	// Leer desde page (Tokio) con fallbacks (Kioto)
	const headerText =
		page.texts?.[0]?.content || "¿Qué es el JR Pass y cómo usarlo?";
	const trainSticker = getImageSrc("train-sticker");

	// Lógica especial para la guía de Tokio: header #24221a en primera página, #e24217 en las siguientes
	const pageOrder =
		page.order !== undefined
			? page.order
			: page.data?.order !== undefined
				? page.data.order
				: -1;
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor =
		isTokioGuide && pageOrder > 0
			? "#e24217"
			: headerBackgroundColor || "rgb(242, 139, 53)";
	// Verde como en Template184 (consejo) para Kioto; naranja para Tokio
	const useGreenTheme = !isTokioGuide;
	const passBoxBg = useGreenTheme ? "#e0f2e8" : "rgb(255, 227, 204)";
	const passBoxBorder = useGreenTheme ? "#5ba374" : "rgb(242, 139, 53)";
	const accentColor = useGreenTheme ? "#3d805e" : "rgb(213, 124, 49)";
	const consejoBoxBg = useGreenTheme ? "#e0f2e8" : "rgb(255, 227, 204)";
	const consejoBoxBorder = useGreenTheme ? "#5ba374" : "rgb(242, 139, 53)";

	// Textos desde page (Tokio) o por defecto (Kioto). Tokio: [0]=header, [1]=intro, [2][3]=sección1, [4][5]=sección2, [6]=sabías que
	const introText = page.texts?.[1]?.content;
	const tiposTitle = page.texts?.[2]?.content;
	const dondeTitle = page.texts?.[3]?.content;
	const dondeText = page.texts?.[4]?.content;
	const comprarTitle = page.texts?.[5]?.content;
	const comprarText = page.texts?.[6]?.content;
	const comprarLink = "https://gyg.me/WpbCqPbc";
	const usarTitle = page.texts?.[7]?.content;
	const activarTitle = page.texts?.[8]?.content;
	const activarText = page.texts?.[9]?.content;
	const consejoTitle = page.texts?.[10]?.content;
	const consejoText = page.texts?.[11]?.content;

	// Font family a usar
	const currentFontFamily = fontFamily || "'Poppins', sans-serif";

	// Estilos
	const h3 = {
		fontFamily: currentFontFamily,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "12px",
		marginTop: 0,
	};

	const contentColor = textColor || "#444";

	const p = {
		fontFamily: currentFontFamily,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	const passBox = {
		backgroundColor: passBoxBg,
		border: `3px solid ${passBoxBorder}`,
		borderRadius: "12px",
		padding: "12px 16px",
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		minWidth: 100,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${currentFontFamily} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${currentFontFamily} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "20px !important",
				},
				"& .marginless": {
					marginBottom: "0px !important",
				},
			}}
		>
			{/* CABECERA */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 800,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
			</Box>

			{/* INTRO */}
			<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: "13px", color: contentColor }}>
				<Box
					component="p"
					className="marginless"
					sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}
				>
					{introText}
				</Box>
			</Box>

			{/* INFO */}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px",
					fontSize: "13px",
					color: contentColor,
					position: "relative",
				}}
			>
				<Box component="h3" sx={h3}>
					{tiposTitle}
				</Box>
				<Box
					sx={{
						display: "flex",
						flexDirection: isSmallScreen ? "column" : "row",
						gap: "12px",
						marginBottom: "16px",
					}}
				>
					<Box sx={passBox}>
						<Box
							sx={{
								fontSize: "14px",
								fontWeight: 600,
								color: accentColor,
								marginBottom: "6px",
								fontFamily: currentFontFamily,
							}}
						>
							7 días
						</Box>
						<Box
							sx={{
								fontSize: "13px",
								color: contentColor,
								fontFamily: currentFontFamily,
							}}
						>
							≈ 300€
						</Box>
					</Box>
					<Box sx={passBox}>
						<Box
							sx={{
								fontSize: "14px",
								fontWeight: 600,
								color: accentColor,
								marginBottom: "6px",
								fontFamily: currentFontFamily,
							}}
						>
							14 días
						</Box>
						<Box
							sx={{
								fontSize: "13px",
								color: contentColor,
								fontFamily: currentFontFamily,
							}}
						>
							≈ 480€
						</Box>
					</Box>
					<Box sx={passBox}>
						<Box
							sx={{
								fontSize: "14px",
								fontWeight: 600,
								color: accentColor,
								marginBottom: "6px",
								fontFamily: currentFontFamily,
							}}
						>
							21 días
						</Box>
						<Box
							sx={{
								fontSize: "13px",
								color: contentColor,
								fontFamily: currentFontFamily,
							}}
						>
							≈ 600€
						</Box>
					</Box>
				</Box>
				<Box component="h3" sx={h3}>
					{dondeTitle}
				</Box>
				<Box
					component="p"
					sx={{
						...p,
						marginBottom: "20px",
						margin: "0 !important",
						marginBottom: "20px !important",
					}}
				>
					{dondeText}
				</Box>
				<Box component="h3" sx={h3}>
					{comprarTitle}
				</Box>
				<Box
					component="p"
					sx={{
						...p,
						marginBottom: "20px",
						margin: "0 !important",
						marginBottom: "20px !important",
					}}
				>
					{comprarText}
				</Box>

				<Box
					sx={{
						backgroundColor: "#fff8db",
						border: "2px solid #f5c400",
						borderRadius: "12px",
						padding: "10px 12px",
						marginBottom: "22px",
						fontSize: "12px",
						fontFamily: currentFontFamily,
						color: contentColor,
						position: "relative",
					}}
				>
					{!isSmallScreen && trainSticker && (
						<Box
							component="img"
							src={trainSticker}
							alt=""
							onError={() => setTrainStickerError(true)}
							sx={{
								width: 110,
								position: "absolute",
								right: "-20px",
								top: "-20px",
							}}
						/>
					)}
					<Box component="strong">🎫 Comprar JR Pass</Box>{" "}
					<Box
						component="a"
						href={comprarLink}
						target="_blank"
						rel="noopener noreferrer"
						sx={{
							color: "#caa100",
							textDecoration: "underline",
							fontWeight: "bold",
						}}
					>
						aquí
					</Box>
					.
				</Box>
				<Box component="h3" sx={h3}>
					{activarTitle}
				</Box>
				<Box
					component="p"
					sx={{
						...p,
						marginBottom: "20px",
						margin: "0 !important",
					}}
				>
					{activarText}
				</Box>
			</Box>

			{/* CONSEJO */}
			<Box
				sx={{
					backgroundColor: consejoBoxBg,
					border: `3px solid ${consejoBoxBorder}`,
					borderRadius: "16px",
					padding: "16px",
					fontSize: "12px",
					color: contentColor,
					margin: "0 16px 20px",
					position: "relative",
					marginTop: isSmallScreen ? "40px" : 0,
				}}
			>
				<Box
					component="h4"
					sx={{
						marginTop: 0,
						marginBottom: "8px",
						fontSize: "13px",
						color: accentColor,
						fontWeight: 700,
						textTransform: "uppercase",
					}}
				>
					{consejoTitle}
				</Box>
				<Box
					component="p"
					sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}
					className="marginless"
					dangerouslySetInnerHTML={{ __html: consejoText }}
				/>
				{isSmallScreen && trainSticker && (
					<Box
						component="img"
						src={trainSticker}
						alt=""
						onError={() => setTrainStickerError(true)}
						sx={{
							width: 110,
							position: "absolute",
							right: "-20px",
							top: "-80px",
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template38.thumbnail = "/images/template-1.png";

export default Template38;
